var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "List",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-list","viewBox":"0 0 420 420"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <ellipse cx="36.1" cy="42.2" rx="35.6" ry="36.2"/>
  <ellipse cx="36.1" cy="210.3" rx="35.6" ry="36.2"/>
  <ellipse cx="36.1" cy="377.3" rx="35.6" ry="36.2"/>
  <rect width="278.7" height="85.4" x="140.8" y="0.4"/>
  <rect width="278.7" height="85.4" x="140.8" y="167.2"/>
  <rect width="278.7" height="85.4" x="140.8" y="334"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/list.svg